import produce from 'immer';
import {
  type CurrentUserPostVoteStatus,
  setQueryData,
  UserVoteOnPostCommentDocument,
} from '@graphql/reactQuery';
import { createBatchingInputStore } from '@store/batchInput';

export function commentReplyFilterQueryKey(postCommentId: string) {
  return {
    postCommentId,
  };
}

export const { batchedKeys, useBatchedKey } = createBatchingInputStore({
  chunkLimit: 50,
});

export function setVoteStatus({
  postCommentId,
  voteStatus,
  upvoteCount,
}: {
  postCommentId: string;
  voteStatus: CurrentUserPostVoteStatus;
  upvoteCount: number;
}) {
  const postCommentIds = batchedKeys.keys.get(postCommentId);

  if (!postCommentIds) {
    return;
  }

  setQueryData(
    {
      query: UserVoteOnPostCommentDocument,
      variables: {
        input: {
          postCommentIds,
        },
      },
    },
    previousData => {
      if (!previousData) return previousData;

      return produce(previousData, draft => {
        for (const value of draft.data.userVoteOnPostComment) {
          if (value.postCommentId === postCommentId) {
            value.voteStatus = voteStatus;
            value.upvoteCount = upvoteCount;
            return;
          }
        }

        draft.data.userVoteOnPostComment.push({
          voteStatus,
          upvoteCount,
          postCommentId,
        });
      });
    },
  );
}
